import * as React from "react"
import { cn } from "@/lib/utils"

const sizeMap = {
  sm: "h-10",
  md: "h-[50px]",
  lg: "h-14",
}

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  error?: boolean
  helperText?: string
  size?: "sm" | "md" | "lg"
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, helperText, size = "md", startIcon, endIcon, ...props }, ref) => {
    return (
      <div className="space-y-1 w-full">
        <div className="relative flex items-center">
          {startIcon && (
            <span className="absolute left-3 flex items-center text-muted-foreground pointer-events-none">
              {startIcon}
            </span>
          )}
          <input
            type={type}
            className={cn(
              "flex rounded-[0.5rem] w-full border border-border-light hover:border-border px-3 text-md ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 font-medium",
              sizeMap[size],
              startIcon && "pl-9",
              endIcon && "pr-9",
              error && "border-destructive focus-visible:ring-destructive",
              className
            )}
            ref={ref}
            {...props}
          />
          {endIcon && (
            <span className="absolute right-3 flex items-center text-muted-foreground pointer-events-none">
              {endIcon}
            </span>
          )}
        </div>
        {helperText && (
          <span className={cn("text-xs", error ? "text-destructive" : "text-muted-foreground")}>
            {helperText}
          </span>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
